// extracted by mini-css-extract-plugin
module.exports = {"container":"MyFilter_container__3_ek3","mobileContainer":"MyFilter_mobileContainer__26hf8","heading3":"MyFilter_heading3__2FQVI","spinAround":"MyFilter_spinAround__1YtLM"};